import { render, staticRenderFns } from "./home_swiper.vue?vue&type=template&id=6e6b866d&scoped=true&"
import script from "./home_swiper.vue?vue&type=script&lang=js&"
export * from "./home_swiper.vue?vue&type=script&lang=js&"
import style0 from "./home_swiper.vue?vue&type=style&index=0&id=6e6b866d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6b866d",
  null
  
)

export default component.exports